import React, { Component } from 'react';
import { connect } from 'react-redux';

import FormattedDate from '../fields/dates/FormattedDate';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';

const log = new Logger('TRANSACTION_INVOICE_ROW', LOG_LEVELS.DEBUG);

class InvoiceRow extends Component {

  render() {
    log.debug('render(): ', this.props);

    if (!this.props.invoiceRows) {
      return(
        <div><LanguageStringResolver string='transactionBlank_noData'/></div>
      )
    }

    return(
      <table>
        <thead>
          <tr>
            <th colSpan="4"><LanguageStringResolver string='transactionInvoice_lineDetails'/></th>
            <th><LanguageStringResolver string='transactionInvoice_valueExclVAT'/></th>
            <th><LanguageStringResolver string='transactionInvoice_TaxableBasis'/></th>
            <th><LanguageStringResolver string='transactionInvoice_VATAmount'/></th>
          </tr>
        </thead>
      {this.props.invoiceRows.map((item, index) => (
        <tbody key={index}>

          <tr>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_description'/></p></td>
            <td><p>{item.description}</p></td>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_transactionID'/></p></td>
            <td><p>{item.transactionID} {item.transactionDescription}</p></td>
            <td className={withFullStoryExclude()}>
              <span className="formData"><FormattedCurrencyValue value={item.valueExclVAT}/>
              <span>{' ' + this.props.currency1}</span></span>
            </td>
            <td className={withFullStoryExclude()}>
              <span className="formData"><FormattedCurrencyValue value={item.valueTaxableBasis}/>
              <span>{' ' + this.props.currency1}</span></span>
            </td>
            <td className={withFullStoryExclude()}>
              <span className="formData"><FormattedCurrencyValue value={item.valueVAT}/>
              <span>{' ' + this.props.currency1}</span></span>
            </td>
          </tr>

          <tr>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_appliedVATRate'/></p></td>
            <td><p>{item.appliedVATRate}</p></td>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_transactionType'/></p></td>
            <td><p>{item.transactionType}</p></td>
            <td className={withFullStoryExclude()}>
              <span className="formData"><FormattedCurrencyValue value={item.valueExclVAT2}/>
              <span>{' ' + this.props.currency2}</span></span>
            </td>
            <td className={withFullStoryExclude()}>
              <span className="formData"><FormattedCurrencyValue value={item.valueTaxableBasis2}/>
              <span>{' ' + this.props.currency2}</span></span>
            </td>
            <td className={withFullStoryExclude()}>
              <span className="formData"><FormattedCurrencyValue value={item.valueVAT2}/>
              <span>{' ' + this.props.currency2}</span></span>
            </td>
          </tr>

          <tr>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_VATCode'/></p></td>
            <td><p>{item.lineVATCode}</p></td>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_serviceCode'/></p></td>
            <td><p>{item.serviceCode}</p></td>
            <td className={withFullStoryExclude()}>
              <span className="formData"><FormattedCurrencyValue value={item.valueExclVAT3}/>
              <span>{' ' + this.props.currency3}</span></span>
            </td>
            <td className={withFullStoryExclude()}>
              <span className="formData"><FormattedCurrencyValue value={item.valueTaxableBasis3}/>
              <span>{' ' + this.props.currency3}</span></span>
            </td>
            <td className={withFullStoryExclude()}>
              <span className="formData"><FormattedCurrencyValue value={item.valueVAT3}/>
              <span>{' ' + this.props.currency3}</span></span>
            </td>
          </tr>

          <tr>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_VATCodeDescription'/></p></td>
            <td><p>{item.lineVATCodeDescription}</p></td>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_accountNumber'/></p></td>
            <td><p>{item.accountNumber}</p></td>
          </tr>

          <tr>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_genericVATCode'/></p></td>
            <td><p>{item.genericVATCode}</p></td>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_referenceInvoiceNumber'/></p></td>
            <td><p>{item.referenceInvoiceNumber}</p></td>
          </tr>

          <tr>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_shipFrom'/></p></td>
            <td><p>{item.shipFromCountry}</p></td>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_referenceInvoiceNumber'/></p></td>
            <td><p>{item.referenceInvoiceNumber}</p></td>
          </tr>

          <tr>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_shipTo'/></p></td>
            <td><p>{item.shipToCountry}</p></td>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_referenceTaxableBasis'/></p></td>
            <td><p>{item.referenceTaxableBasis}</p></td>
          </tr>

          <tr>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_goodType'/></p></td>
            <td><p>{item.goodType}</p></td>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_referenceVAT'/></p></td>
            <td><p>{item.referenceVAT}</p></td>
          </tr>

          <tr>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_itemType'/></p></td>
            <td><p>{item.itemType}</p></td>
            <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_exemptionReason'/></p></td>
            <td><p>{item.exemptionReason}</p></td>
          </tr>
          <tr>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_dateOfSupply'/></p></td>
              <td><p><FormattedDate value={item.dateOfSupply}/></p></td>
              <td><p className="semi-bold"><LanguageStringResolver string='transactionInvoice_itemIdentifier'/></p></td>
              <td><p>{item.itemIdentifier}</p></td>
          </tr>
        </tbody>
      ))}
      </table>
   );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {}
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(InvoiceRow);
